import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MoreFiltersData } from './more-filters.model';

@Component({
  template: `<miq-more-filters
    [dataFilters]="data"
    [isClipboard]="true"
    [isModal]="true"
    (filtersChange)="filtersChange($event)"
    [overrideDisable]="data.overrideDisable"
  ></miq-more-filters>`,
  standalone: false,
})
export class ClipboardMoreFiltersDialogWrapperComponent {
  data: MoreFiltersData;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: MoreFiltersData,
    private dialogRef: MatDialogRef<ClipboardMoreFiltersDialogWrapperComponent>
  ) {
    this.data = data;
  }

  filtersChange(userFilters): void {
    this.dialogRef.close(userFilters);
  }
}
